export const webhookConfigurationParameterOverridePrefix = "cfg:";

export const toConfigurationParameterOverrideKey = (paramName: string) => {
    return `${webhookConfigurationParameterOverridePrefix}${paramName}`;
};

export const isConfigurationParameterOverrideKey = (paramKey: string) => {
    return paramKey.startsWith(webhookConfigurationParameterOverridePrefix);
};

export const getConfigurationParameterNameFromOverrideKey = (paramKey: string) => {
    return isConfigurationParameterOverrideKey(paramKey)
        ? paramKey.substring(webhookConfigurationParameterOverridePrefix.length)
        : paramKey;
};

export const buildWebhookParameterOverridesForRequest = (
    overrides: { [webhookId: string]: { [paramName: string]: string } }
) => {
    const requestOverrides: { [webhookId: string]: { [paramName: string]: string } } = {};

    Object.keys(overrides ?? {}).forEach(webhookId => {
        const params = overrides[webhookId] ?? {};
        const requestParams: { [paramName: string]: string } = {};

        Object.keys(params).forEach(paramName => {
            requestParams[getConfigurationParameterNameFromOverrideKey(paramName)] = params[paramName];
        });

        if (Object.keys(requestParams).length > 0) {
            requestOverrides[webhookId] = requestParams;
        }
    });

    return requestOverrides;
};